// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgFace: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M8.493 11.516c-.832 0-1.5.67-1.5 1.503 0 .833.668 1.502 1.5 1.502s1.5-.669 1.5-1.502c0-.834-.668-1.503-1.5-1.503" />
        <path d="M15.497 11.516c-.832 0-1.5.67-1.5 1.503 0 .833.668 1.502 1.5 1.502.831 0 1.499-.669 1.499-1.502 0-.834-.668-1.503-1.5-1.503" />
        <path
          fillRule="evenodd"
          d="M12.005 0c3.307 0 6.306 1.348 8.483 3.52l-.01-.01A11.952 11.952 0 0 1 24 11.99a12.2 12.2 0 0 1-.277 2.542v.051a11.964 11.964 0 0 1-3.851 6.453 11.22 11.22 0 0 1-.853.68 11.738 11.738 0 0 1-4.498 2.017c-.811.174-1.653.267-2.516.267C5.381 24 0 18.618 0 12 0 5.383 5.381 0 12.005 0m7.98 18.082a9.91 9.91 0 0 0 1.95-4.58v-.01c.073-.494.124-.988.124-1.502 0-.947-.144-1.873-.39-2.748a.099.099 0 0 0-.04.03c-.012.011-.022.021-.032.021-.873.196-2.167.31-3.102.31-4.046 0-7.62-2.018-9.797-5.095-1.17 2.881-3.82 5.197-6.654 6.463l-.041.02c-.031.33-.052.66-.052.999 0 5.197 3.964 9.478 9.037 9.993.34.03.678.051 1.017.051.298 0 .596-.01.893-.04a5.944 5.944 0 0 0 .452-.052 10.039 10.039 0 0 0 5.72-2.81c.33-.33.627-.68.915-1.05"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgFace);
export default Memo;
